export default "__VITE_ASSET__0077af12__"